import {observer} from 'mobx-react';
import {BrowserRouter as Router, Redirect, Route, Switch} from 'react-router-dom';
import {withState} from 'shared/core';
import TimeTrackingPageState from 'main/containers/time_tracking/state/TimeTrackingPageState';
import {policiesRootPath} from 'main/containers/time_tracking/paths';
import {ManageContainer} from 'main/containers/time_tracking/components/manage';
import {DimensionsContainer} from 'main/containers/time_tracking/components/dimensions';
import {PoliciesContainer} from 'main/containers/time_tracking/components/policies';
import {ViewPayScheduleContainer} from 'main/containers/time_tracking/components/policies/components/pay_schedules/components/view';
import {PolicyEditFlow} from 'main/containers/time_tracking/components/policies/components/edit';
import MyTimesheetContainer from 'main/containers/time_tracking/components/my_timesheet/components/MyTimesheetContainer';
import OnboardingContainer from 'main/containers/time_tracking/components/learn_more/components/OnboardingContainer';
import TimesheetsContainer from 'main/containers/time_tracking/components/timesheets/components/TimesheetsContainer';
import PayrollHoursContainer from 'main/containers/time_tracking/components/payroll_hours/components/PayrollHoursContainer';

const TimeTrackingPage = observer(({uiState}) => {
  const {scope} = uiState;
  const managesTimeTracking = scope.manage || scope.policies;

  return (
    <Router basename='/time_tracking'>
      <Switch>
        {scope.learnMore && <Route path='/learn_more' render={() => <OnboardingContainer scope={scope}/>}/>}
        {scope.learnMore && <Redirect from='*' to='/learn_more'/>}
        {scope.myTimesheet && <Route exact path='/' render={() => <MyTimesheetContainer scope={scope}/>}/>}
        {scope.timesheets && <Route path='/timesheets' render={() => <TimesheetsContainer scope={scope}/>}/>}
        {scope.payrollHours && <Route path='/payroll_hours' render={() => <PayrollHoursContainer scope={scope}/>}/>}
        {scope.dimensions && <Route path='/dimensions' render={() => <DimensionsContainer scope={scope}/>}/>}
        {managesTimeTracking && <Route path='/policies/:id/edit' component={PolicyEditFlow}/>}
        {managesTimeTracking && <Route path='/pay_schedules/:id' component={ViewPayScheduleContainer}/>}
        {scope.policies && <Route path='/policies' render={({history}) => <PoliciesContainer history={history} scope={scope}/>}/>}
        {scope.manage && <Route path='/manage' render={({history}) => <ManageContainer history={history} scope={scope}/>}/>}
        {!scope.myTimesheet && scope.timesheets && <Redirect exact from='/' to='/timesheets'/>}
        {!scope.myTimesheet && !scope.timesheets && managesTimeTracking && <Redirect exact from='/' to={policiesRootPath()}/>}
      </Switch>
    </Router>
  );
});

export default withState(TimeTrackingPage, TimeTrackingPageState);
